import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { GameInstructionsContent } from '../../GameInstructionsContent';
import { useEffect } from 'react';
import { useStore } from '@hmpu/powerups.store';

export function HowToPlay() {
  const { __t } = useTranslation('SETTINGS_PANEL');
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  useEffect(() => {
    setPageTitle(__t('pageTitle', 'GAME_INSTRUCTIONS'));
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  useEffect(() => {
    const backButton = document.querySelector("#SettingsPanel-Back") as HTMLElement | null;
    if (backButton) {
      backButton.focus();
    }   
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  return (
    <section className="SettingsPanel-Container">
      <h1 tabIndex={0}>{__t('howToPlay')}</h1>
      <GameInstructionsContent />
    </section>
  );
}
